var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 68,
    viewBox: "0 0 67 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M50.1358 50.8319C59.403 41.5648 59.403 26.5398 50.1358 17.2726C40.8687 8.00549 25.8437 8.00546 16.5765 17.2726C7.30938 26.5397 7.30941 41.5648 16.5765 50.8319C25.8437 60.0991 40.8687 60.099 50.1358 50.8319Z",
    fill: "#5B67EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2895 16.4294C53.2895 18.5294 51.5895 20.2294 49.4895 20.2294C47.3895 20.2294 45.6895 18.5294 45.6895 16.4294C45.6895 14.3294 47.3895 12.6294 49.4895 12.6294C51.5895 12.6294 53.2895 14.3294 53.2895 16.4294Z",
    fill: "#00A7FB",
    stroke: "#FCFCFD",
    strokeWidth: 0.81,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0709 29.0896C37.0709 31.1396 35.4109 32.8097 33.3509 32.8097C31.2909 32.8097 29.6309 31.1496 29.6309 29.0896C29.6309 27.0296 31.2909 25.3696 33.3509 25.3696C35.4109 25.3696 37.0709 27.0296 37.0709 29.0896Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.91 42.7197C40.91 42.5797 40.95 42.4497 40.95 42.3197C40.95 38.1197 37.55 34.7197 33.35 34.7197C29.15 34.7197 25.75 38.1197 25.75 42.3197C25.75 42.4597 25.78 42.5897 25.79 42.7197H40.91Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfileIcon);
export default __webpack_public_path__ + "static/media/user-profile-icon.e35d3fa427b4580e7183a458159e6513.svg";
export { ForwardRef as ReactComponent };